import React from 'react';
import { Backdrop, Box, Fade, IconButton, Modal } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useSiteModalQuery } from '../../../queries/useSiteModalQuery';
import { DynamicZone } from '../../components';
import { icons } from '../../icons';

import './donateModal.css';
import { theme } from '../../theme';

const SiteModalComponent: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  const { data } = useSiteModalQuery();

  React.useEffect(() => {
    const hasSeenModal = sessionStorage.getItem('siteModalSeen');

    if (data?.attributes?.enabled && data?.attributes?.contentComponents && !hasSeenModal) {
      setOpen(true);
      sessionStorage.setItem('siteModalSeen', 'true');
    }
  }, [data]);

  if (
    !data?.attributes?.enabled ||
    !data?.attributes?.contentComponents ||
    data.attributes.contentComponents.length === 0
  ) {
    return null;
  }

  const backgroundColorKey = data?.attributes?.backgroundColor;

  const backgroundColor =
    {
      White: theme.palette.common.white,
      Blue: theme.palette.primary.main,
      Grey: theme.palette.grey[200],
    }[backgroundColorKey] || theme.palette.grey[200];
  if (!data?.attributes.enabled) return null;

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: backgroundColor,
    boxShadow: 24,
    p: 0,
    maxWidth: '900px',
    maxHeight: '90vh',
    overflow: 'auto',

    '& .mdc-typography': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& .mdc-layout-grid': {
        width: '100%',
      },
    },
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      sx={{
        border: 'none',
        outline: 'none',
        '&:focus': {
          outline: 'none',
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <IconButton
            onClick={handleClose}
            disableFocusRipple
            disableRipple
            sx={{
              cursor: 'pointer',
              position: 'absolute',
              top: '0',
              right: '0',
              color: 'common.white',
              backgroundColor: 'grey.500',
              fontSize: { xs: '1rem', sm: '1.5rem' },
              borderRadius: '0 0 0 100%',
              width: { xs: '40px', sm: '50px' },
              height: { xs: '40px', sm: '50px' },
              display: 'flex',
              justifyContent: 'end',
              alignItems: 'start',
              padding: '.5rem .5rem 0 0',
              border: 'none',
              outline: 'none',
              overflow: 'hidden',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: 'grey.600',
              },
              '&:focus': {
                outline: 'none',
                boxShadow: 'none',
              },
              '&:focus-visible': {
                outline: 'none',
                boxShadow: 'none',
              },
            }}
          >
            <FontAwesomeIcon icon={icons.close} />
          </IconButton>

          <DynamicZone key="siteModal" components={data.attributes.contentComponents} spacing={0} />
        </Box>
      </Fade>
    </Modal>
  );
};

export { SiteModalComponent as SiteModal };
